module.exports = __webpack_public_path__ + "static/vegetarian-d2b762963a749223443083efe7fc4a0f.png";